var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-date-picker',{attrs:{"label":_vm.label,"is-range":"","size":""},on:{"change":_vm.handleInput},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }